import React from "react";
import PropTypes from "prop-types";
import NoIndex from "../NoIndex";
import {markup} from "../../../utils/markup";

import styles from "./description.module.scss";

export default function ProductDescription({itemDescription, title}) {
  return itemDescription && (
    <NoIndex>
      <div className={styles.root}>
        <h2 className={styles.title}>{title}</h2>
        <div className={styles.text} dangerouslySetInnerHTML={markup(itemDescription)} />
      </div>
    </NoIndex>
  );
}

ProductDescription.propTypes = {
  content: PropTypes.shape({
    description: PropTypes.string
  })
};
